import React, { FC } from 'react';
// eslint-disable-next-line import/no-unresolved
import { ButtonProps } from '@altibox/design-system-component-lib/dist/components/button/button';

import { ImageProps } from 'src/components/image';

import { StyledButton, StyledIcon } from './icon-button.styled';

interface OwnProps {
  icon: ImageProps;
  iconBeforeText?: boolean;
}

export type IconButtonProps = OwnProps & Omit<ButtonProps, 'theme' | 'iconWrapper'>;

export const IconButton: FC<IconButtonProps> = (props) => {
  const { icon, iconBeforeText = true, ...rest } = props;

  return (
    <StyledButton
      {...rest}
      iconWrapper={{
        icon: <StyledIcon {...icon} />,
        placeIconBeforeText: iconBeforeText,
      }}
    />
  );
};
